// extracted by mini-css-extract-plugin
export default {"HoverDesc":"HoverDesc_HoverDesc__9zgAR","description":"HoverDesc_description__K2+h7","right":"HoverDesc_right__ZKaKV"};